import { NeedIssues } from 'react-components/admin-dashboard/components/NeedsContent/NeedIssues/NeedIssues';
import { NeedsActivity } from 'react-components/admin-dashboard/components/NeedsContent/NeedsActivity/NeedsActivity';
import { NeedsCategories } from 'react-components/admin-dashboard/components/NeedsContent/NeedsCategories/NeedsCategories';
import { NeedsContent } from 'react-components/admin-dashboard/components/NeedsContent/NeedsContent';
import { NeedDomains } from 'react-components/admin-dashboard/components/NeedsContent/NeedsDomains/NeedDomains';
import { NeedZcodes } from 'react-components/admin-dashboard/components/NeedsContent/NeedZcodes/NeedZcodes';

export const needsContentRoutes = [
  {
    path: '/admin-dashboard/needs-content',
    element: <NeedsContent />,
  },
  {
    path: '/admin-dashboard/needs-content/activities',
    element: (
      <NeedsContent>
        <NeedsActivity />
      </NeedsContent>
    ),
  },
  {
    path: '/admin-dashboard/needs-content/categories',
    element: (
      <NeedsContent>
        <NeedsCategories />
      </NeedsContent>
    ),
  },
  {
    path: '/admin-dashboard/needs-content/issues',
    element: (
      <NeedsContent>
        <NeedIssues />
      </NeedsContent>
    ),
  },
  {
    path: '/admin-dashboard/needs-content/zcodes',
    element: (
      <NeedsContent>
        <NeedZcodes />
      </NeedsContent>
    ),
  },
  {
    path: '/admin-dashboard/needs-content/domains',
    element: (
      <NeedsContent>
        <NeedDomains />
      </NeedsContent>
    ),
  },
  {
    path: '/admin-dashboard/needs-content/activities/:id/edit',
    element: (
      <NeedsContent>
        <NeedsActivity />
      </NeedsContent>
    ),
  },
  {
    path: '/admin-dashboard/needs-content/domains/:id/edit',
    element: (
      <NeedsContent>
        <NeedDomains />
      </NeedsContent>
    ),
  },
  {
    path: '/admin-dashboard/needs-content/categories/:id/edit',
    element: (
      <NeedsContent>
        <NeedsCategories />
      </NeedsContent>
    ),
  },
  {
    path: '/admin-dashboard/needs-content/issues/:id/edit',
    element: (
      <NeedsContent>
        <NeedIssues />
      </NeedsContent>
    ),
  },
  {
    path: '/admin-dashboard/needs-content/zcodes/:id/edit',
    element: (
      <NeedsContent>
        <NeedZcodes />
      </NeedsContent>
    ),
  },
];
